var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation"},[(_vm.$vuetify.breakpoint.smAndDown)?_c('v-icon',{staticClass:"mr-2 pa-1",on:{"click":function($event){return _vm.$emit('showDrawer')}}},[_vm._v("\n    menu\n  ")]):_c('NavigationButtons')],1)}
var staticRenderFns = []

export { render, staticRenderFns }